import 'typeface-roboto'
import 'typeface-raleway'
import 'raleway-cyrillic'
import 'foundation-sites/dist/css/foundation.min.css'
import '@css/variables.css'
import '@css/index.css'
import '@css/Button.css'
import '@css/Header.css'
import '@css/Footer.css'
import '@css/RichText.css'
import './i18n/i18n'

import store from '@store/index'
import React from 'react'
import { createRoot } from 'react-dom/client'
import { Provider } from 'react-redux'
import { BrowserRouter } from 'react-router-dom'

import App from './App'
import { ConfirmProvider } from './providers/ConfirmProvider'

createRoot(document.getElementById('root')!).render(
  <Provider store={store}>
    <BrowserRouter>
      <ConfirmProvider>
        <App />
      </ConfirmProvider>
    </BrowserRouter>
  </Provider>
)
